import { UnixTimestamp } from "kreate-common/modules/business-types";
import { z } from "zod";

export const Params = z.object({
  policyId: z.string(),
});

export type Params = z.infer<typeof Params>;

export const RestorePolicyStatusResult = z.enum([
  "preparing",
  "processing",
  "processed",
  "failed",
]);

export type RestorePolicyStatusResult = z.infer<
  typeof RestorePolicyStatusResult
>;

export const Result = z.union([
  z.object({
    createdAt: UnixTimestamp,
    finishedAt: UnixTimestamp.nullish(),
    status: RestorePolicyStatusResult,
    progress: z.object({
      total: z.number(),
      processing: z.number(),
      done: z.number(),
      failed: z.number(),
    }),
  }),
  z.object({
    status: z.literal("none"),
  }),
]);

export type Result = z.infer<typeof Result>;

export const TrackRestorePolicyJob$Params = Params;
export type TrackRestorePolicyJob$Params = Params;
export const TrackRestorePolicyJob$Result = Result;
export type TrackRestorePolicyJob$Result = Result;
